module.exports = __webpack_public_path__ + "img/bz2.bef978a1.png";